import * as endPoint from '../networkUtility/endpoints';
import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';

import * as localStorageActionType from '../LocalStorage/ActionTypes';
import { setLocalStorage } from '../LocalStorage/SetLocalStorage';
import { getLocalStorage } from '../LocalStorage/GetLocalStorage'

import { toggleNotificationVisibility } from './networkNotification';
import { toggleLoader } from './loader'
import { NotificationType } from '../Utility/InterFacesAndEnum';

import { handle401Status } from '../Utility/Utility';

interface LoginState {
    isLoading: boolean,
    isLoggedin: boolean,
    isAuthenticated: boolean,
    activeUserCount: number,
    without2faLogin: boolean
}

interface Loading {
    isLoading: boolean
}

interface Login {
    isLoggedin: boolean,
    isAuthenticated: boolean
}

interface Without2FaLogin {
    without2faLogin: boolean
}

const loginInitialState: LoginState = {
    isLoading: false,
    isLoggedin: false,
    isAuthenticated: false,
    activeUserCount: 0,
    without2faLogin: false
}

interface SigninAccount {
    emailId: string,
    password: string
}

export const createLogin = createAsyncThunk(
    'auth/login',
    async (loginObj: SigninAccount, { dispatch }) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        const response = await fetch(endPoint.login,
            {
                method: 'POST',
                body: JSON.stringify(loginObj),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                }
            })
            .then((response) => {
                // console.log(response)
                return response.json()
            })
            .then((data) => {

                console.log(data)
                if (data.statusCode === 401) {
                    handle401Status();
                }

                if (data.statusCode === 200) {
                    let publicUserId = data.result.publicUserId;
                    let token = {
                        accessToken: data.result.accessToken,
                        refreshToken: data.result.refreshToken


                    }
                    setLocalStorage(localStorageActionType.SET_ACCESS_REFRESH_TOKEN, token);
                    if (data.errorMsg === "Login Successfully") {
                        setLocalStorage(localStorageActionType.SET_PUBLIC_USER_ID, publicUserId);

                    }
                    dispatch(toggleLogin({
                        isLoggedin: true,
                        isAuthenticated: false
                    }));

                    dispatch(toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.success,
                        message: data.errorMsg
                    }));
                    console.log(data)
                } else {
                    dispatch(toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.error,
                        message: data.errorMsg
                    }));
                    dispatch(toggleLoader({
                        isLoading: false
                    }))
                }
            })
            .catch((error) => {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.error,
                    message: "something went wrong!"
                }));
                dispatch(toggleLoading({
                    isLoading: false
                }));
            })
            .finally(() => {
                dispatch(toggleLoading({
                    isLoading: false
                }));
            })
    }
);

export const verify2FA = createAsyncThunk(
    'verify 2FA OTP',
    async (payload: string, { dispatch }) => {
        await fetch(endPoint.verifyOtp, {
            method: 'POST',
            body: payload,
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActionType.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            }
        })
            .then((response) => {
                console.log(response)
                return response.json();
            })
            .then((data) => {
                if (data.statusCode === 401) {
                    handle401Status();
                }

                if (data.statusCode === 200) {

                    let responseObj = data.result;
                    let publicUserId = responseObj.publicUserId;
                    let tokenObj = {
                        accessToken: responseObj.accessToken,
                        refreshToken: responseObj.refreshToken
                    }

                    setLocalStorage(localStorageActionType.SET_ACCESS_REFRESH_TOKEN, tokenObj);
                    setLocalStorage(localStorageActionType.SET_PUBLIC_USER_ID, publicUserId);

                    dispatch(toggleLogin({
                        isLoggedin: true,
                        isAuthenticated: responseObj.authenticated
                    }));

                    dispatch(toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.success,
                        message: data.errorMsg
                    }));
                } else {
                    dispatch(toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.error,
                        message: data.errorMsg
                    }));
                }

            }).catch((err) => {
                console.log(err)
            })
    }
);



export const forgotOtpPassword = createAsyncThunk(
    'forgot password',

    async (payload: string, { dispatch }) => {
        // console.log( payload)
        await fetch(endPoint.forgotPswd, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                //  Authorization: `Bearer ${getLocalStorage(localStorageActionType.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            }
        })
            .then((response) => {
                console.log(response)
                return response.json();
            })
            .then((data) => {
                console.log(data)
                if (data.statusCode === 401) {
                    handle401Status();
                }
                if (data.statusCode === 200) {
                    let responseObj = data.result;
                    let publicUserId = responseObj.publicUserId;

                    setLocalStorage(localStorageActionType.SET_PUBLIC_USER_ID, publicUserId);


                    dispatch(toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.success,
                        message: data.errorMsg
                    }));
                } else {
                    dispatch(toggleNotificationVisibility({
                        isVisible: true,
                        status: NotificationType.success,
                        message: data.errorMsg
                    }));
                }

            }).then((err) => {
                console.log(err);
                return err;
            })
    }
);

export const resetPassword = createAsyncThunk(
    'reset password',
    async (payload: any, { dispatch }) => {
        // console.log("payload :",payload)
        let publicUID = getLocalStorage(localStorageActionType.GET_PUBLIC_USER_ID);
        // console.log("public id", publicUID)
        await fetch(`${endPoint.resetPswd}${publicUID}`, {
            method: "PUT",
            body: JSON.stringify(payload),
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActionType.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8"
            }
        }).then((response) => {
            return response.json();
        }).then((data) => {
            // console.log(data)
            if (data.statusCode === 400) {
                handle401Status();
            }

            if (data.statusCode === 200) {

                dispatch(toggleLogin({
                    isLoggedin: true,
                    isAuthenticated: true
                }));

                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.success,
                    message: data.errorMsg
                }));
            } else {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.success,
                    message: data.errorMsg
                }));
            }

        }).catch((err) => {
            console.log(err)
            return err;
        })

    }
)

export const getActiveUserCount = createAsyncThunk(
    'get active user count',
    async (payload: void, { dispatch }) => {
        dispatch(toggleLoading({
            isLoading: true
        }));
        await fetch(endPoint.getUserCount, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActionType.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            }
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.statusCode === 403) {
                    handle401Status();
                }
                dispatch(setActiveUserCount({
                    count: data.result
                }))

            })
            .finally(() => {
                dispatch(toggleLoading({
                    isLoading: false
                }));
            });
    }
)

const loginSlice = createSlice({
    name: 'login',
    initialState: loginInitialState,
    reducers: {
        resetLoginState: () => {
            return loginInitialState
        },
        toggleLoading: (state, action: PayloadAction<Loading>) => {
            return {
                ...state,
                isLoading: action.payload.isLoading
            }
        },
        toggleLogin: (state, action: PayloadAction<Login>) => {
            return {
                ...state,
                isLoggedin: action.payload.isLoggedin,
                isAuthenticated: action.payload.isAuthenticated
            }
        },
        Without2faLogin: (state, action: PayloadAction<Without2FaLogin>) => {
            return {
                ...state,
                without2faLogin: action.payload.without2faLogin
            }
        },
        setActiveUserCount: (state, action: PayloadAction<{ count: number }>) => {
            return {
                ...state,
                activeUserCount: action.payload.count
            }
        }
    }
});

export const { resetLoginState, toggleLoading, toggleLogin, setActiveUserCount, Without2faLogin } = loginSlice.actions;
export default loginSlice.reducer;